import "react-phone-number-input/style.css";

import CheckBox from "./CheckBox";
import PhoneInput from "react-phone-number-input";
import PropTypes from "prop-types";
import React from "react";
import eyeClosed from "assets/icons/eyeClosed.svg";
import eyeIcon from "assets/icons/eye.svg";
import { forwardRef } from "react";
import styled from "styled-components";
import { useEffect } from "react";
import { useField } from "formik";
import { useMemo } from "react";
import { useState } from "react";

export const FormGroupWrapper = styled.div`
  .fieldWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px;
    height: ${(props) => (props.fieldStyle === "longText" ? "auto" : "4.8rem")};
    border: 1px solid var(--grey_10);
    position: relative;
    padding: 0 12px;

    &.error {
      border-color: var(--danger);
    }
  }

  input,
  textarea,
  select {
    display: block;
    color: ${(props) => props.color ?? "var(--grey_1)"};
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;

    &::placeholder {
      color: var(--grey_9);
    }
  }

  select {
    cursor: pointer;
    color: #6e7191;
  }

  .toggleShow {
    display: none;
  }

  &.password {
    input,
    textarea {
      width: calc(100%-5rem);
    }

    .toggleShow {
      display: inline;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.5rem;
      height: 2rem;
    }
  }

  .loaderWrapper {
    position: absolute;
    top: 50%;
    right: 1.5rem;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  textarea {
    height: 14.4rem;
    padding: 1.5rem 0;
    line-height: 20px;
  }

  .dropdownIcon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 1.5rem;
    pointer-events: none;
  }

  .errorText {
    display: block;
    width: 100%;
    text-align: left;
    margin-top: 0.6rem;
  }

  .dateFilterWrapper {
    width: 100%;
    border: none;

    .react-datepicker-wrapper {
      width: 100%;
      height: 100%;
    }

    .react-datepicker__input-time-container {
      display: flex;
      align-items: center;
      width: 100%;
      gap: 7.5rem;
    }

    .react-datepicker-time__input-container {
      font-size: 16px;
      font-style: normal;
      font-weight: 450;
      line-height: 20px;
    }

    .react-datepicker-time__input {
    }

    .react-datepicker-time__caption {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    }
  }
`;

export const FormGroupLabel = styled.label`
  display: block;
  color: var(--body_text);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 0.3rem;
  text-align: left;

  &.showTextCount {
    display: flex;
    justify-content: space-between;
  }

  sup {
    color: var(--danger);
  }
  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

const CheckboxField = styled.div``;

const handleToggleShowPassword = (id) => {
  const field = document.querySelector(`#${id}`);

  if (field.type === "password") {
    field.type = "text";
  } else {
    field.type = "password";
  }
};

const handleCheckboxSelect = (e, id) => {
  e.preventDefault();

  const selectedElCheckbox = document.querySelector(`#${id}`);
  selectedElCheckbox.click();
};

/**
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} props.fieldStyle
 * @param {string} [props.type]
 * @param {string} props.name
 * @param {string} [props.value]
 * @param {string} [props.label]
 * @param {string} [props.placeholder]
 * @param {boolean} [props.required]
 * @param {string | number} [props.defaultValue]
 * @param {string} [props.color]
 * @param {Function} [props.onChange]
 * @param {number} [props.rowIndex]
 * @param {any} [props.phoneInput]
 * @param {boolean} [props.showTextCount]
 * @param {number} [props.maxLength]
 * @returns
 */

const FormGroup = ({
  className,
  fieldStyle,
  type = "text",
  name,
  value,
  label,
  placeholder,
  required = true,
  defaultValue,
  color,
  onChange,
  rowIndex,
  phoneInput,
  showTextCount,
  maxLength,
  ...props
}) => {
  const [field, meta] = useField({ ...props, name });
  const [showPassword, setShowPassword] = useState(false);
  const [phoneVal, setPhoneVal] = useState(field.value);

  if (typeof value === "string") field.value = value;

  const CustomPhoneInput = forwardRef(({ value, onChange, onBlur }, ref) => (
    <input
      style={{ paddingLeft: "0.6rem" }}
      ref={ref}
      {...field}
      {...meta}
      className="textSmall"
      id={name}
      name={name}
      placeholder={placeholder}
      value={value}
      required={required || false}
      onBlur={(e) => {
        field.onBlur(e);
        onBlur(e);
      }}
      onChange={(e) => {
        field.onChange(e);
        onChange(e);
      }}
      {...props}
      autoComplete="off"
    />
  ));

  // eslint-disable-next-line
  const __customPhoneInput = useMemo(() => CustomPhoneInput, []);

  useEffect(() => {
    document.querySelectorAll(`input[type="number"]`).forEach((input) => {
      input.addEventListener("mousewheel", function (e) {
        e.target.blur();
      });
    });
    // eslint-disable-next-line
  }, []);

  if (type === "checkbox") {
    return (
      <CheckboxField className={`flex-row align-center ${className ?? ""}`}>
        <CheckBox className="checkbox" id={name} name={name} />
        <FormGroupLabel
          className="cursorPointer"
          htmlFor={name}
          onClick={(e) => handleCheckboxSelect(e, name)}
          style={{ marginBottom: 0, marginLeft: "0.5rem" }}
        >
          {label}
        </FormGroupLabel>
      </CheckboxField>
    );
  }

  return (
    <>
      <FormGroupWrapper className={className} fieldStyle={fieldStyle}>
        {label && (
          <FormGroupLabel
            htmlFor={name}
            className={`${showTextCount ? "showTextCount" : ""}`}
          >
            <>
              {label}
              {required && <sup>*</sup>}
            </>
            {showTextCount && (
              <div className="textDescription">
                {field.value.length}/{maxLength}
              </div>
            )}
          </FormGroupLabel>
        )}
        <div
          className={`fieldWrapper${
            meta.error && meta.touched ? " error" : ""
          }${phoneInput ? "  phoneInput" : ""}`}
        >
          {fieldStyle === "shortText" &&
            (phoneInput ? (
              <PhoneInput
                defaultCountry="NG"
                inputComponent={__customPhoneInput}
                value={phoneVal}
                onChange={setPhoneVal}
                international
                countryCallingCodeEditable={false}
              />
            ) : (
              <>
                <input
                  {...field}
                  className="textSmall"
                  id={name}
                  type={type}
                  defaultValue={defaultValue}
                  placeholder={placeholder}
                  onChange={(e) => {
                    onChange && onChange(rowIndex, name, e.target.value);
                    field.onChange(e);
                  }}
                  {...props}
                  autoComplete="off"
                />
                {type === "password" && (
                  <img
                    src={showPassword ? eyeClosed : eyeIcon}
                    alt="eye"
                    className="toggleShow cursorPointer"
                    onClick={(e) => {
                      setShowPassword((prev) => !prev);
                      handleToggleShowPassword(name);
                    }}
                  />
                )}
              </>
            ))}
          {fieldStyle === "longText" && (
            <>
              <textarea
                className="textSmall"
                id={name}
                name={name}
                required={required}
                defaultValue={defaultValue}
                placeholder={placeholder}
                {...field}
                {...props}
                autoComplete="off"
                maxLength={maxLength}
              />
            </>
          )}
        </div>
        {meta.error && meta.touched && (
          <span className="textDescription colorDanger errorText">
            {meta.error}
          </span>
        )}
      </FormGroupWrapper>
    </>
  );
};

FormGroup.propTypes = {
  className: PropTypes.string,
  fieldStyle: PropTypes.string.isRequired,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  color: PropTypes.string,
  rowIndex: PropTypes.number,
};

export default FormGroup;
